/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RequestAccessForm,
  RequestAccessForm$Outbound,
  RequestAccessForm$outboundSchema,
} from "../components/requestaccessform.js";

export type RequestAccessSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RequestAccessRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  requestAccessForm: RequestAccessForm;
};

/** @internal */
export type RequestAccessSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RequestAccessSecurity$outboundSchema: z.ZodMiniType<
  RequestAccessSecurity$Outbound,
  RequestAccessSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function requestAccessSecurityToJSON(
  requestAccessSecurity: RequestAccessSecurity,
): string {
  return JSON.stringify(
    RequestAccessSecurity$outboundSchema.parse(requestAccessSecurity),
  );
}

/** @internal */
export type RequestAccessRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  RequestAccessForm: RequestAccessForm$Outbound;
};

/** @internal */
export const RequestAccessRequest$outboundSchema: z.ZodMiniType<
  RequestAccessRequest$Outbound,
  RequestAccessRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    requestAccessForm: RequestAccessForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      requestAccessForm: "RequestAccessForm",
    });
  }),
);

export function requestAccessRequestToJSON(
  requestAccessRequest: RequestAccessRequest,
): string {
  return JSON.stringify(
    RequestAccessRequest$outboundSchema.parse(requestAccessRequest),
  );
}
